module.exports = __webpack_public_path__ + "img/digital-tahavol.bdc6118.svg";